import React from "react";
import "./homeBanner.css";
import LeftFace from "../../assets/leftface.png";
import CenterFace from "../../assets/centerface.png";
import RightFace from "../../assets/rightface.png";

const HomeBanner = () => {
  return (
    <div className="home-banner mt-3 mb-12">
      <div>
        <p className="absolute text-4xl md:text-5xl top-[80px] md:top-[100px] left-[20px] w-4/5 lg:w-2/5 font-rubik text-white">
          NFT access lists, simplified.
        </p>
        <p className="absolute top-[180px]  md:top-[200px] left-[20px] mt-3 font-rubik w-4/5 text-white text-sm sm:text-base ">
          PREMINT is used by the top NFT artists in the world to build access
          lists and to randomly select the collectors and community members to
          win a spot. 800,000 collectors have joined lists without spending any
          gas.
        </p>
        <button className="absolute rounded-lg bottom-[20px] sm:bottom-[40px] md:bottom-[60px] left-[20px] bg-[color:var(--purple-color)] py-3 px-6 text-white mt-3 ">
          Learn More
        </button>
        <div className="hidden lg:absolute lg:flex banner-gallery">
          <img src={LeftFace} alt="" />
          <img src={CenterFace} alt="" />
          <img src={RightFace} alt="" />
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;
